import { array, dateTime, defineAction, enumerated, number, object, string } from '../../../prix'
import entrepreneurAgentCheckAction from './agentCheckStream.action.json' assert { type: 'json' }

const entrepreneurAgentCheckDefinition = defineAction({
  ...entrepreneurAgentCheckAction,
  input: object({
    entrepreneurCpf: string(),
  }),
  output: object({
    state: enumerated({
      searchingAgents: 'searching_agents',
      agentAccepted: 'agent_accepted',
      allAgentsRefused: 'all_agents_refused',
      noAgentsAvailable: 'no_agents_available',
    }),
    pendingCount: number(),
    refusedCount: number(),
    agent: object({
      cpf: string(),
      latitude: number(),
      longitude: number(),
      accuracy: number(),
      lastGeolocationUpdate: dateTime(),
      geodesicDistanceMeters: number(),
      drivingDistanceMeters: number(),
      status: enumerated({
        waitingAnswer: 'waiting_answer',
        refused: 'refused',
        accepted: 'accepted',
      }),
    }),
    agentsPreview: array(
      object({
        cpf: string(),
        latitude: number(),
        longitude: number(),
        accuracy: number(),
        lastGeolocationUpdate: dateTime(),
        geodesicDistanceMeters: number(),
        drivingDistanceMeters: number(),
        status: enumerated({
          waitingAnswer: 'waiting_answer',
          refused: 'refused',
          accepted: 'accepted',
        }),
      }),
    ),
  }),
})

export default entrepreneurAgentCheckDefinition
